const globals = {};
const locks = {};
const frames = {};

/**
 * Sends events between multiple components to allow them to scroll in
 * unison.
 * - To use, create a ScrollSync in the constructor of your component.
 * - In componentDidMount(), call this.scrollSync.start(), 
 * - In componentWillUnmount(), call this.scrollSync.stop()
 * - Call this.scrollSync.onScroll( event ) when your local component scrolls.
 * - The onRemoteScroll function given in the ScrollSync's constructor should 
 * immediately set the scroll position of your component as desired.
 **/
class ScrollSync {
  /** 
   * Create a ScrollSync
   * @param {object} options the options object
   * @param {string} options.name the name of the synchronization. Defaults to 'main'
   * @param {function} options.onRemoteScroll this function should set the scroll position of your component
   **/
  constructor({
    name,
    onRemoteScroll
  }) {
    this.name = `scrollSync.${typeof name === 'string' && name.length > 0 ? name : 'main'}`;
    this.locked = false;
    this.onRemoteScroll = onRemoteScroll;
  }

  /**
   * Call this in componentDidMount()
   **/
  start() {
    const c = globals[this.name];
    if (c == null) {
      globals[this.name] = [this];
    } else if (!c.includes(this)) {
      c.push(this);
    }
    // window.addEventListener( this.name, this.onReceivedRemoteScroll )
  }

  /**
   * Call this in componentWillUnmount()
   **/
  stop() {
    const c = globals[this.name];
    if (c != null) {
      const idx = c.indexOf(this);
      if (idx >= 0) {
        c.splice(idx, idx);
      }
    }
    // window.removeEventListener( this.name, this.onReceivedRemoteScroll )
  }

  /**
   * Private function that listens to events. This will call the onRemoteScroll
   * if the sync is not locked
   **/
  onReceivedRemoteScroll = event => {
    // if ( this.locked !== true ) {
    if (locks[this.name] !== true) {
      const {
        scrollTop,
        scrollLeft,
        extra
      } = event.detail;
      this.onRemoteScroll({
        scrollTop,
        scrollLeft,
        extra,
        event
      });
    }
  };

  /**
   * Call this when your local scroll region updates
   **/
  onScroll = (event, extra = null) => {
    const {
      scrollTop,
      scrollLeft
    } = event.target;
    if (locks[this.name] != null && locks[this.name] !== this) {
      return;
    }
    if (frames[this.name] != null) {
      window.cancelAnimationFrame(frames[this.name]);
      frames[this.name] = null;
    }
    frames[this.name] = window.requestAnimationFrame(() => {
      locks[this.name] = this;
      try {
        globals[this.name].forEach(s => {
          if (s !== this) {
            s.onRemoteScroll({
              scrollTop,
              scrollLeft,
              extra,
              event
            });
          }
        });
      } catch (x) {
        console.log('error scrolling', x);
      }
      locks[this.name] = null;
      frames[this.name] = null;
    });
    // this.locked = true
    // window.dispatchEvent( new CustomEvent( this.name, { detail : { scrollTop, scrollLeft, extra } } ) )
    // this.locked = false 
  };
}
export default ScrollSync;